import { ComponentRoute } from '@/classes'

const PollingLogRoutes = {
  PollingLogListView: new ComponentRoute('/pollinglog', 'PollingLogListView')
  // PollingLogView: new ComponentRoute('/pollinglog/:pollingLogFieldId', 'PollingLogView'),
  // PollingLogDetail: new ComponentRoute('/pollinglog/:pollingLogFieldId', 'PollingLogDetail')
}

export default PollingLogRoutes